import type { BuilderElement } from '@/utils/builder/types';
import { generateId } from '@/utils/builder/id-utils';

const createGalleryPlaceholderSrc = (label: string): string => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="400" height="240" viewBox="0 0 400 240" fill="none">
      <rect width="400" height="240" fill="#F3F4F6"/>
      <rect x="24" y="24" width="352" height="192" rx="20" fill="#E5E7EB"/>
      <path d="M112 164L164 112L204 152L248 108L308 164V180H112V164Z" fill="#9CA3AF"/>
      <circle cx="160" cy="92" r="18" fill="#9CA3AF"/>
      <text x="200" y="208" text-anchor="middle" fill="#4B5563" font-family="Arial, sans-serif" font-size="22" font-weight="600">${label}</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

const createDefaultImageElement = (label: string): BuilderElement => {
  return {
    id: generateId(),
    type: 'image',
    src: createGalleryPlaceholderSrc(label),
    alt: label,
    styles: {
      width: '100%',
      height: 'auto',
      padding: '10px',
      margin: '0',
    },
    _isNew: true,
    _needsSync: true,
  };
};

export const createDefaultGalleryElement = (): BuilderElement => {
  const id = generateId();

  return {
    id,
    type: 'gallery',
    styles: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '10px',
      width: '100%',
      padding: '10px',
    },
    children: [
      createDefaultImageElement('Gallery image 1'),
      createDefaultImageElement('Gallery image 2'),
      createDefaultImageElement('Gallery image 3'),
    ],
    _isNew: true,
    _needsSync: true,
  };
};
